document.addEventListener('DOMContentLoaded', function () {
	
	//
	// Parse les select pour ajouter disabled surl la première option si besoin
	//
	let optionsDisabledEl = document.querySelectorAll('select option[value=""]:first-child');
	let optionsArray = Array.prototype.slice.call(optionsDisabledEl, 0);
	optionsArray.forEach(function(el){
		el.disabled = true;
	})


	//
	// Parse les select material
	//
	let selectsWatch = document.querySelectorAll('.formMaterial-group .select select');
	// console.log(selectsWatch);
	selectsWatch.forEach(function (el) {
		checkSelectIfOptionIsChecked(el);
		el.addEventListener('change', (event) => {
		 	// console.log('change', el);
			// var inputText = event.target.value;
			// console.log(inputText);
			// console.log(el.value);
			checkSelectIfOptionIsChecked(el);
		})
	})
	// Permet d'indiquer que 1 option est choisie
	function checkSelectIfOptionIsChecked (el) {
		// console.log(el.value);
		if (el.value !== '') {
			el.parentNode.classList.add('has-option-selected');
		} else {
			el.parentNode.classList.remove('has-option-selected');
		}
	}

	//
	// Parse form "wpcf7-form" pr supprimer l'attribut novalidate
	//
	let wpcf7FormNoV = document.querySelectorAll('form.wpcf7-form[novalidate]');
	wpcf7FormNoV.forEach(function (el) {
		el.removeAttribute('novalidate');
	})


	//
	// Auto resize du text area
	// https://stackoverflow.com/questions/454202/creating-a-textarea-with-auto-resize
	//
	// var tx = document.getElementsByTagName('textarea');
	let tx = document.querySelectorAll('.formMaterial-group textarea');
	for (var i = 0; i < tx.length; i++) {
		tx[i].setAttribute('style', 'height:' + (tx[i].scrollHeight) + 'px;overflow-y:hidden;');
		tx[i].addEventListener("input", OnInput, false);
	}
	function OnInput() {
		this.style.height = 'auto';
		this.style.height = (this.scrollHeight) + 'px';
	}


	//
	// Ajoute l'attribut required au champ avec aria-required="true"
	// Comme cela on bénéfici de la validation native en front par les navigateurs
	//
	let wpcf7FormElsRequired = document.querySelectorAll('form.wpcf7-form *[aria-required=true]');
	wpcf7FormElsRequired.forEach(function (el) {
		el.setAttribute('required', true);
		// console.log(el);
	})

	//
	// DOM event envoi du formulaire
	//
	let wpcf7Forms= document.querySelectorAll('.wpcf7');
	wpcf7Forms.forEach(function (el) {

		let btnSubmit = document.querySelector('.wpcf7-submit');
		el.addEventListener( 'submit', function( event ) {
			// https://contactform7.com/dom-events/
			// console.log('submit', event);
			btnSubmit.setAttribute('disabled', true);
		}, false );

		el.addEventListener( 'wpcf7submit', function( event ) {
			// https://contactform7.com/dom-events/
			// console.log('wpcf7submit', event);
			btnSubmit.removeAttribute('disabled');
		}, false );
	})

})